export function getOrCreateDeviceId(): string {
  const key = "device_id";
  let id = localStorage.getItem(key);
  if (id) return id;

  const array = new Uint8Array(16);
  crypto.getRandomValues(array);
  id = Array.from(array)
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
  localStorage.setItem(key, id);
  return id;
}

export function getStoredSessionId(): string | null {
  return localStorage.getItem("sessionId");
}

export function storeSessionId(id: string) {
  localStorage.setItem("sessionId", id);
}
